import MuiCircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";

const MuiSpinner = styled(MuiCircularProgress)`
  &.MuiCircularProgress-root {
    color: #f05623;
  };
`;

export function Spinner({ isLoading, screenCenter = true, ...baseProps}) {
  if (!isLoading) {
    return null;
  }

  return (
    <div className={`${screenCenter ? "tw-flex tw-justify-center tw-items-center tw-w-full" : ""}`}>
      <MuiSpinner {...baseProps} />
    </div>
  );
}

export default Spinner;
